// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1V8kd","cell":"ColumnAccessor_cell__3Qx0K","firstCellAccent":"ColumnAccessor_firstCellAccent__35Pd1"};